module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tplheader'), _vm._v(" "), _c('tplLeftPanel'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "fixed-top-menu-outer",
    attrs: {
      "id": "fixed-top-menu-outer"
    }
  }, [_c('div', {
    staticClass: "fixed-top-menu"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        path: '/card_owner/edit'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("Új kártyabirtokos")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "main-panel"
    }
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-panel-top-btn-group"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        path: '/card_owner/edit'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("Új kártyabirtokos")])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('inputbox', {
    attrs: {
      "id": "name",
      "keydownEnter": _vm.searchClick,
      "label": "Név",
      "name": "name"
    },
    model: {
      value: (_vm.search.name),
      callback: function($$v) {
        _vm.$set(_vm.search, "name", $$v)
      },
      expression: "search.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('inputbox', {
    attrs: {
      "inputCheck": "neptuncode",
      "maxlength": "6",
      "id": "neptuncode",
      "keydownEnter": _vm.searchClick,
      "label": "Neptunkód",
      "name": "neptuncode"
    },
    model: {
      value: (_vm.search.neptuncode),
      callback: function($$v) {
        _vm.$set(_vm.search, "neptuncode", $$v)
      },
      expression: "search.neptuncode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('inputbox', {
    attrs: {
      "inputCheck": "orgware",
      "maxlength": "8",
      "id": "orgware_id",
      "keydownEnter": _vm.searchClick,
      "label": "Törzsszám",
      "name": "orgware_id"
    },
    model: {
      value: (_vm.search.orgware_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "orgware_id", $$v)
      },
      expression: "search.orgware_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('inputbox', {
    attrs: {
      "id": "email",
      "keydownEnter": _vm.searchClick,
      "label": "Email",
      "name": "email"
    },
    model: {
      value: (_vm.search.email),
      callback: function($$v) {
        _vm.$set(_vm.search, "email", $$v)
      },
      expression: "search.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchClick
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("Keresés")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.card_owners.length) ? _c('div', [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.card_owners), function(owner) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(owner.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.neptun_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.ad_username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(owner.orgware_id))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "icon-list"
    }, [_c('li', {
      staticClass: "dropdown"
    }, [_vm._m(5, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, [_c('li', {
      staticClass: "dropdown-header"
    }, [_vm._v("Opciók")]), _vm._v(" "), _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/card_owner/edit/',
          query: {
            id: owner.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v("Szerkeszt")])], 1)])])])])])
  }), 0)]), _vm._v(" "), _c('pagination', {
    attrs: {
      "showcombo": "1",
      "limit": _vm.query.limit,
      "amount": _vm.query.amount
    },
    on: {
      "pageChanged": _vm.pageChanged
    },
    model: {
      value: (_vm.query.page),
      callback: function($$v) {
        _vm.$set(_vm.query, "page", $$v)
      },
      expression: "query.page"
    }
  })], 1) : _c('div', [_vm._v("\n                  Nem található kártyabirtokos.\n                ")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("Kezdőőoldal")]), _vm._v(" "), _c('li', [_vm._v("Kártyabirtokosok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")]), _vm._v("Kártyabirtokosok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Kártyabirtokosok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel-sub-heading"
  }, [_c('h4', [_vm._v("Kereső")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Név")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Telefon")]), _vm._v(" "), _c('th', [_vm._v("Neptunkód")]), _vm._v(" "), _c('th', [_vm._v("AD Felh.név")]), _vm._v(" "), _c('th', [_vm._v("Törzsszám")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0beb0843"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cardowners.vue
// module id = 45
// module chunks = 0